import { render, staticRenderFns } from "./dialogForm.vue?vue&type=template&id=477fd2e1&scoped=true&"
import script from "./dialogForm.vue?vue&type=script&lang=js&"
export * from "./dialogForm.vue?vue&type=script&lang=js&"
import style0 from "./dialogForm.vue?vue&type=style&index=0&id=477fd2e1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477fd2e1",
  null
  
)

export default component.exports